import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { IMAGES } from "../data/site";
import { RegistrationMark } from "../components/Shared";

const ease = [0.22, 1, 0.36, 1];

const Hero = () => (
  <section className="relative overflow-hidden bg-canvas" data-testid="hero-section">
    <div className="grid-lines absolute inset-0" />
    <div className="pointer-events-none absolute -right-40 top-10 h-[520px] w-[520px] rounded-full bg-tint blur-3xl" />

    <div className="relative mx-auto grid w-full max-w-7xl items-center gap-14 px-6 pb-20 pt-32 lg:grid-cols-12 lg:px-10 lg:pb-28 lg:pt-44">
      <div className="lg:col-span-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease }}
          className="flex items-center gap-3"
        >
          <span className="h-px w-8 bg-brand2" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-brand">
            Commercial Printing — Bangalore
          </span>
        </motion.div>

        <h1 className="mt-7 font-display text-4xl font-bold leading-[1.06] tracking-tight text-navy sm:text-5xl lg:text-6xl xl:text-7xl">
          {["Precision", "in", "Every", "Print."].map((word, i) => (
            <motion.span
              key={word}
              className={`mr-3 inline-block sm:mr-4 ${word === "Print." ? "text-brand" : ""}`}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.15 + i * 0.1, ease }}
            >
              {word}
            </motion.span>
          ))}
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.6, ease }}
          className="mt-6 max-w-xl text-base leading-relaxed text-slate sm:text-lg"
          data-testid="hero-subheadline"
        >
          Premium commercial printing backed by advanced technology, rigorous quality control and dependable execution.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.75, ease }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <Link to="/contact" data-testid="hero-quote-btn" className="btn-primary group">
            Request a Quote
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
          <Link to="/capabilities" data-testid="hero-capabilities-btn" className="btn-secondary">
            Explore Our Capabilities
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.8 }}
          className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 border-t border-line pt-6"
        >
          <span className="text-xs font-medium uppercase tracking-[0.16em] text-slate">Offset · Multi-Colour · Heidelberg</span>
          <span className="hidden h-1 w-1 rounded-full bg-line sm:block" />
          <span className="text-xs font-medium uppercase tracking-[0.16em] text-slate">C · M · Y · K — Registration Locked</span>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.9, delay: 0.35, ease }}
        className="relative lg:col-span-6"
      >
        <div className="relative overflow-hidden rounded-2xl border border-line bg-white shadow-[0_24px_60px_-30px_rgba(23,32,51,0.25)]">
          <img
            src={IMAGES.hero}
            alt="Offset printing press in operation"
            className="h-[320px] w-full object-cover sm:h-[420px] lg:h-[540px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy/50 via-navy/5 to-transparent" />
          <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between gap-4">
            <div className="rounded-xl border border-white/30 bg-white/85 px-4 py-3 backdrop-blur-md">
              <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-brand">Production Floor</p>
              <p className="mt-0.5 text-sm font-semibold text-navy">Sudhamanagar, Bangalore</p>
            </div>
            <RegistrationMark className="hidden sm:block opacity-90" size={40} />
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);

export default Hero;
